/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  FindEcoModulationProductsQueryResponse,
  FindEcoModulationProductsQueryParams,
} from "../types/FindEcoModulationProducts.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const findEcoModulationProductsQueryKey = (
  params: FindEcoModulationProductsQueryParams
) =>
  [
    { url: "/v1/product/find-eco-modulation-products" },
    ...(params ? [params] : []),
  ] as const

export type FindEcoModulationProductsQueryKey = ReturnType<
  typeof findEcoModulationProductsQueryKey
>

/**
 * @summary Find eco-modulation products
 * {@link /v1/product/find-eco-modulation-products}
 */
export async function findEcoModulationProducts(
  params: FindEcoModulationProductsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindEcoModulationProductsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/product/find-eco-modulation-products`,
    params,
    ...requestConfig,
  })
  return res
}

export function findEcoModulationProductsQueryOptions(
  params: FindEcoModulationProductsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findEcoModulationProductsQueryKey(params)
  return queryOptions<
    ResponseConfig<FindEcoModulationProductsQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindEcoModulationProductsQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return findEcoModulationProducts(params, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Find eco-modulation products
 * {@link /v1/product/find-eco-modulation-products}
 */
export function useFindEcoModulationProducts<
  TData = ResponseConfig<FindEcoModulationProductsQueryResponse>,
  TQueryData = ResponseConfig<FindEcoModulationProductsQueryResponse>,
  TQueryKey extends QueryKey = FindEcoModulationProductsQueryKey,
>(
  params: FindEcoModulationProductsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindEcoModulationProductsQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? findEcoModulationProductsQueryKey(params)

  const query = useQuery(
    {
      ...findEcoModulationProductsQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
